import React, { useRef } from 'react'
import { FormattedMessage } from 'react-intl'
import { AnimatePresence } from 'framer-motion'
import { useMe } from 'contexts/me'
import { useConfiguration } from 'contexts/configuration'
import { useCommandBar } from 'contexts/command-bar'
import { cls } from 'utilities/dom'
import { useGetItemLabel } from '../../utilities'
import {
    ListItem,
    Button,
    Label, KeyHintInner
} from './s'
import Avatar from 'components/avatar'
import { iconMap as typeToIconMap } from 'components/group'
import { AvatarWrapper, Deactivated } from 'components/person/s'
import { ArrowRight as Navigate } from 'styled-icons/feather'
import { itemHeight } from './constants'

const Entity = ({ item, isActive }) => {
    const itemRef = useRef()

    const { isItMyOwnId } = useMe()
    const { getKnownGroupTypes } = useConfiguration()

    const { execute } = useCommandBar()

    const getItemLabel = useGetItemLabel()

    const { entity, entityType } = item
    const isGroup = getKnownGroupTypes().includes(entityType)
    const Icon = typeToIconMap?.[entityType] ?? null

    return (
        <ListItem
            style={{ '--item-height': `${itemHeight}px` }}
            ref={itemRef}>
            <Button
                onClick={() => execute(item)}
                className={cls([
                    'neutral',
                    isActive && 'active',
                    'has-icon'
                ])}>
                {isGroup && (
                    <>
                        <Icon size={20} />
                        <Label>
                            <span className="label">
                                {getItemLabel(item)}
                            </span>
                        </Label>
                    </>
                )}
                {!isGroup && (
                    <>
                        <AvatarWrapper>
                            {!entity.status?.active && <Deactivated size={12} />}
                            <Avatar
                                who={entity}
                                size={20} />
                        </AvatarWrapper>
                        <Label>
                            <span className="label">
                                {getItemLabel(item)}
                            </span>
                            {isItMyOwnId(entity.id) && (
                                <span className="sub-label">
                                    <FormattedMessage
                                        id="noun_you"
                                        defaultMessage="You" />
                                </span>
                            )}
                        </Label>
                    </>
                )}
                {!!isActive && (
                    <AnimatePresence>
                        <KeyHintInner animate={isActive ? 'active' : 'inactive'}>
                            <Navigate size={16} />
                        </KeyHintInner>
                    </AnimatePresence>
                )}
            </Button>
        </ListItem>
    )
}

export default Entity